import axios from "axios";
import { SERVER_BASE_URL, } from "@/local/local_settings";
import i18n from "@/i18n";

// const isProduction = process.env.NODE_ENV === 'production';

const initialState = {
    lastAttemptToReachServerFailed: false,
    selectedAreaPk: null,
    selectedArea: null,
    selectedActivityPk: null,
    selectedActivity: null,
    selectedFromDate: new Date(new Date().getFullYear(), new Date().getMonth(), 1).toLocaleDateString(),
    selectedToDate: new Date().toLocaleDateString(),
    activities: [],
    activitiesAreLoading: true,
};

const getters = {
    serverURLNoPath: () => SERVER_BASE_URL,
    serverURL: () => SERVER_BASE_URL + 'API',
    // 1 = Monday. This is a preparation for internationalization
    firstDayOfWeek: () => 1,
    earningsPeriods: () => [{
            name: i18n.tc('Today'),
            value: 1,
        },
        {
            name: i18n.tc('Yesterday'),
            value: 2,
        },
        {
            name: i18n.tc('ThisWeek'),
            value: 3,
        },
        {
            name: i18n.tc('PreviousWeek'),
            value: 4,
        },
        {
            name: i18n.tc('ThisMonth'),
            value: 5,
        },
        {
            name: i18n.tc('PreviousMonth'),
            value: 6,
        },
    ],
};

const actions = {
    getActivitiesForCurrentArea({commit, state}) {
        axios
            .get(getters.serverURL() + '/get_activities_for_selected_area/')
            .then(response => {
                    commit('setActivities', response.data);

                    let newActivity = state.activities.find(activity => activity.is_selected);
                    let newActivityPk = newActivity.pk;

                    commit('setSelectedActivity', newActivity);
                    commit('setSelectedActivityPk', newActivityPk);

                    commit('setActivitiesAreLoading', false);
                }
            )
            .catch((error) => {
                console.log(error);
                commit('activitiesAreLoading', false);
            });
    },
};

const mutations = {
    initializeCommonStore(state) {
        // Remember to remove items from local storage on logout. See resetCommonStorageOnLogout(...) below

        if (localStorage.getItem('selectedFromDate') != null) {
            state.selectedFromDate = localStorage.getItem('selectedFromDate');
        }
        if (localStorage.getItem('selectedToDate') != null) {
            state.selectedToDate = localStorage.getItem('selectedToDate');
        }
    },
    resetCommonStorageOnLogout(state) {
        localStorage.removeItem('selectedFromDate')
        localStorage.removeItem('selectedToDate')

        state.selectedFromDate = new Date(new Date().getFullYear()
                , new Date().getMonth()
                , 1
            ).toLocaleDateString();

        state.selectedToDate = new Date().toLocaleDateString();
    },
    setLastAttemptToReachServerFailed (state, payload) {
        state.lastAttemptToReachServerFailed = payload;
    },
    setSelectedArea(state, payload) {
        state.selectedArea = payload;
    },
    setSelectedAreaPk(state, payload) {
        state.selectedAreaPk = payload;
    },
    setSelectedActivity(state, payload) {
        state.selectedActivity = payload;
    },
    setSelectedActivityPk(state, payload) {
        state.selectedActivityPk = payload;
    },
    setActivities(state, payload) {
        state.activities = payload;
    },
    setActivitiesAreLoading(state, payload) {
        state.activitiesAreLoading = payload;
    },
    setSelectedFromDate(state, payload) {
        localStorage.setItem('selectedFromDate', payload);
        state.selectedFromDate = payload;
    },
    setSelectedToDate(state, payload) {
        localStorage.setItem('selectedToDate', payload);
        state.selectedToDate = payload;
    },
};

export default {
    namespaced: true,
    state: initialState,
    getters,
    actions,
    mutations,
};